var map = {
	"./_MG_0431.jpg": 40042,
	"./_MG_0452.jpg": 96273,
	"./_MG_0500.jpg": 63691,
	"./_MG_0503.jpg": 14636,
	"./_MG_0514.jpg": 93006,
	"./_MG_0517.jpg": 20867,
	"./_MG_0537.jpg": 34740,
	"./_MG_0679.jpg": 39626,
	"./_MG_0690.jpg": 37940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28475;